<!-- eslint-disable -->
<template>
  <!-- 승용차 가로 -->
  <svg v-if="type === 'car' && direction === 'H'" viewBox="0 0 84 42" class="vehicle-svg">
    <path d="M 5 14 C 5 7, 12 5, 22 5 L 62 5 C 72 5, 79 7, 79 14 C 82 18, 82 24, 79 28 C 79 35, 72 37, 62 37 L 22 37 C 12 37, 5 35, 5 28 Z" class="car-body-path"></path>
    <path d="M 64 6 C 71 10, 71 32, 64 36" class="car-detail-line"></path>
    <path d="M 51 9 C 57 11, 57 31, 51 33 L 55 31 C 60 27, 60 15, 55 11 Z" class="car-glass-path"></path>
    <path d="M 23 10 C 17 12, 17 30, 23 32 L 19 30 C 15 26, 15 16, 19 12 Z" class="car-glass-path"></path>
    <path d="M 52 2 L 57 2 L 55 5 L 51 5 Z" class="car-mirror"></path>
    <path d="M 52 40 L 57 40 L 55 37 L 51 37 Z" class="car-mirror"></path>
    <ellipse cx="34" cy="21" rx="2.5" ry="1.5" class="car-roof-point"></ellipse>
  </svg>

  <!-- 승용차 세로 -->
  <svg v-else-if="type === 'car' && direction === 'V'" viewBox="0 0 42 84" class="vehicle-svg">
    <path d="M 14 5 C 7 5, 5 12, 5 22 L 5 62 C 5 72, 7 79, 14 79 C 18 82, 24 82, 28 79 C 35 79, 37 72, 37 62 L 37 22 C 37 12, 35 5, 28 5 Z" class="car-body-path"></path>
    <path d="M 6 64 C 10 71, 32 71, 36 64" class="car-detail-line"></path>
    <path d="M 9 51 C 11 57, 31 57, 33 51 L 31 55 C 27 60, 15 60, 11 55 Z" class="car-glass-path"></path>
    <path d="M 10 23 C 12 17, 30 17, 32 23 L 30 19 C 26 15, 16 15, 11 18 Z" class="car-glass-path"></path>
    <path d="M 2 52 L 2 57 L 5 55 L 5 51 Z" class="car-mirror"></path>
    <path d="M 40 52 L 40 57 L 37 55 L 37 51 Z" class="car-mirror"></path>
    <ellipse cx="21" cy="34" rx="1.5" ry="2.5" class="car-roof-point"></ellipse>
  </svg>

  <!-- 버스 가로 -->
  <svg v-else-if="type === 'bus' && direction === 'H'" viewBox="0 0 126 42" class="vehicle-svg">
    <rect x="3" y="4" width="120" height="34" rx="3" class="bus-body-rect"></rect>
    <line x1="14" y1="4" x2="14" y2="38" class="bus-line"></line>
    <line x1="115" y1="4" x2="115" y2="38" class="bus-line"></line>
    <rect x="26" y="13" width="16" height="16" rx="3" class="bus-hatch-outer"></rect>
    <rect x="29" y="16" width="10" height="10" rx="1.5" class="bus-hatch-inner"></rect>
    <rect x="84" y="13" width="16" height="16" rx="3" class="bus-hatch-outer"></rect>
    <rect x="87" y="16" width="10" height="10" rx="1.5" class="bus-hatch-inner"></rect>
    <g class="bus-grill">
      <line x1="46" y1="10" x2="80" y2="10"></line>
      <line x1="46" y1="13" x2="80" y2="13"></line>
      <line x1="46" y1="16" x2="80" y2="16"></line>
      <line x1="46" y1="19" x2="80" y2="19"></line>
      <line x1="46" y1="22" x2="80" y2="22"></line>
      <line x1="46" y1="25" x2="80" y2="25"></line>
      <line x1="46" y1="28" x2="80" y2="28"></line>
      <line x1="46" y1="31" x2="80" y2="31"></line>
    </g>
  </svg>

  <!-- 버스 세로 -->
  <svg v-else viewBox="0 0 42 126" class="vehicle-svg">
    <rect x="4" y="3" width="34" height="120" rx="3" class="bus-body-rect"></rect>
    <line x1="4" y1="14" x2="38" y2="14" class="bus-line"></line>
    <line x1="4" y1="115" x2="38" y2="115" class="bus-line"></line>
    <rect x="13" y="26" width="16" height="16" rx="3" class="bus-hatch-outer"></rect>
    <rect x="16" y="29" width="10" height="10" rx="1.5" class="bus-hatch-inner"></rect>
    <rect x="13" y="84" width="16" height="16" rx="3" class="bus-hatch-outer"></rect>
    <rect x="16" y="87" width="10" height="10" rx="1.5" class="bus-hatch-inner"></rect>
    <g class="bus-grill">
      <line x1="10" y1="46" x2="10" y2="80"></line>
      <line x1="13" y1="46" x2="13" y2="80"></line>
      <line x1="16" y1="46" x2="16" y2="80"></line>
      <line x1="19" y1="46" x2="19" y2="80"></line>
      <line x1="22" y1="46" x2="22" y2="80"></line>
      <line x1="25" y1="46" x2="25" y2="80"></line>
      <line x1="28" y1="46" x2="28" y2="80"></line>
      <line x1="31" y1="46" x2="31" y2="80"></line>
    </g>
  </svg>
</template>

<script>
export default {
  name: 'VehicleSvg',
  props: {
    type: {
      type: String,
      required: true,
    },
    direction: {
      type: String,
      required: true,
    },
  },
}
</script>
